import { Component, OnInit, Input, ViewChild, ElementRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import * as moment from 'moment';

import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';
import { LtmsDataTableV2Component } from '../../../ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsLoaderComponent } from '../../../ltms-loader/ltms-loader.component';
@Component({
    selector: 'app-history-panel',
    templateUrl: './history-panel.component.html',
    styleUrls: ['./history-panel.component.scss'],
    imports: [FormsModule, NgIf, NgFor, LtmsDataTableV2Component, LtmsLoaderComponent]
})
export class HistoryPanelComponent implements OnInit {
  @ViewChild('litmusfeedhistorysearch') litmusfeedhistorysearch!: ElementRef;
  @Input() feedId: string = '';
  @Input() brandDetails: any = {};
  destroyRef = inject(DestroyRef);
  columns: any = [{
    header: "Event name",
    dataKey: "event_name",
    enabled: true,
    dataType: "string",
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "18%"
    },
    order: 2
  }, {
    header: "Date and Time",
    dataKey: "created_date",
    enabled: true,
    dataType: "string",
    sortBy: "time_in_ms",
    isColumnSorted: true,
    sorted: false,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "13%"
    },
    order: 2
  }, {
    header: "Performed by",
    dataKey: "performed_by",
    enabled: true,
    dataType: "string",
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "25%"
    },
    order: 3
  }, {
    header: "Action taken",
    dataKey: "event",
    enabled: true,
    dataType: "string",
    sortingEnabled: false,
    // isHtmlExist:true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
      width: "40%"
    },
    order: 4
  }]
  fieldList: any = [{
    text: "Event name",
    field: "event_name",
  }, {
    text: "Performed by",
    field: "performed_by",
  }, {
    text: "Action taken",
    field: "event",
  }] 
  data: any = []
  pageNumber: number = 0
  isLinkEnabled: boolean = false;
  errorCode: string = "404";
  showFilterFields: boolean = false;
  searchText: string = '';
  selectedFilter: any = {
    text: "Performed by",
    field: "performed_by",
  };
  placeholder: string = "Search by Performed by";
  eventLogs: any = []
  accordionMap: any = {
    "assignee": {
      "display_name": "Assignee"
    },
    "notes": {
      "display_name": "Note"
    },
    "follower": {
      "display_name": "Followers"
    },
    "category": {
      "display_name": "Category"
    },
    "status": {
      "display_name": "Status"
    },
    "tag": {
      "display_name": "Tag"
    }
  }
  projectMetaDataMap: any = {
    "status_list": {},
    "category_list": {},
    "field_definitions": {},
    "tag_list": {},
    "managers": {}
  }
  metaDataFieldsMapper: any = null;
  eventDetailMapper: any = null;
  externalFieldsMapper: any = null
  previousValue: any = "NA";
  currentValue: any = "NA";
  isHistoryLoaded:boolean=false;
  constructor(private _feedService: FeedsService) { }
  ngOnInit(): void {
    if (this.feedId && this.feedId != '') {
      this.initMapper();
      this.prepareAccordionsMap();
      this.updateExternalMap();
      this.getHistory();
    } else {
      this.data = [];
      this.errorCode = "404"
    }
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      const litmusfeedsearchel: any = document.getElementById('litmusfeedhistorysearch');
      if (litmusfeedsearchel && litmusfeedsearchel != event.target && !litmusfeedsearchel.contains(event.target)) {
        this.showFilterFields = false;
      }
      if (this.litmusfeedhistorysearch && this.litmusfeedhistorysearch.nativeElement !== event.target && !this.litmusfeedhistorysearch.nativeElement.contains(event.target)) {
        this.showFilterFields = false;
      }
    });
  }

  toggleFilterFieldList() {
    if (this.showFilterFields) {
      this.showFilterFields = false;
    } else {
      this.showFilterFields = true;
    }
  }

  clearSearch() {
    this.searchText = '';
    this.data = Helpers.deepClone(this.eventLogs);
  }

  filterHistory(event: any) {
    this.showFilterFields = false
    const searchText = event.target.value;
    // Make search case-insensitive by normalizing both search term and field values to lowercase
    const term = (searchText ?? '').toString().toLowerCase().trim();
    if (term) {
      this.data = _.filter(Helpers.deepClone(this.eventLogs), (log: any) => {
        const value = (log[this.selectedFilter.field] ?? '').toString().toLowerCase();
        return value.indexOf(term) >= 0;
      })
    } else {
      this.data = Helpers.deepClone(this.eventLogs)
    }

  }
  changeFilterField(field: any) {
    this.selectedFilter = field;
    this.placeholder = "Search by " + field.text;
    this.showFilterFields = false;
    this.searchText = '';
    this.data = Helpers.deepClone(this.eventLogs);
  }

  prepareHistoryData(response) {
    var tmpHistory: any = [];
    if (response.history && response.history.length) {
      if (!(_.isEmpty(response.dictionary))) {
        this.projectMetaDataMap = response.dictionary;
      }
      response.history.forEach((resp: any) => {
        if (!((!(_.isEmpty(resp.params.old_value)) && !(_.isEmpty(resp.params.new_value))) && _.isEqual(resp.params.new_value, resp.params.old_value))) {
          var dataToPush = {
            "performed_by": this.projectMetaDataMap["managers"][resp.params.performed_by] ? (this.projectMetaDataMap["managers"][resp.params.performed_by]["name"] || this.projectMetaDataMap["managers"][resp.params.performed_by]["email_address"] || "System") : "NA",

            "created_date": /*moment(resp.created_date).fromNow()*/ moment(resp.created_date).format("DD MMM 'YY HH:mm"), //.format("MMM D, YYYY, h:mm A"),
            "time_in_ms": (new Date(resp.created_date)).getTime(),
            "event": this.getFriendlyNameForEvent(resp),
            "event_name": _.get(this.eventDetailMapper, resp.event + ".displayText"),
            "previous_value": this.previousValue,
            "current_value": this.currentValue,
            "manager_type": "Manager/Brand"
          }
          if (dataToPush.performed_by == "NA" && resp.event == "LW_CUSTOMER_COMMENT") {
            dataToPush.performed_by = "Customer";
          }

          // checks for follower added event for easy follow
          if (dataToPush.performed_by == "NA" && (resp.event == "LW_RESPONSE_FOLLOWERS_ADDED")) {
            dataToPush.performed_by = "System";
          }
          tmpHistory.push(dataToPush);
        }

      })
      this.data = _.map(tmpHistory, (obj: any) => {
        return obj;
      });
      this.eventLogs = Helpers.deepClone(this.data)
      this.isHistoryLoaded = true;
    }else{
      this.data = [];
      this.errorCode = '404';
      this.isHistoryLoaded = true;
    }
  }
  linkify(text: string) {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function (url) {
      return '<a href="' + url + '" target="_blank">' + url + '</a>';
    });
  }
  getFriendlyNameForEvent(log) {
    var actualAction: any = null;
    var parameter, parameterTitle;
    // metaDataFieldsMapper has map for all the brand specific fields like status, category etc
    // externalFieldsMapper has map for assignee, followers, notes etc
    if (log.event in this.metaDataFieldsMapper || log.event in this.externalFieldsMapper) {
      try {
        if (log.event == "LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED") {
          var field = (Object.keys(log.params.new_value))[0];
          parameter = this.projectMetaDataMap.field_definitions[field];
          var fieldDisplayText = this.projectMetaDataMap.field_definitions[parameter.group_id];
          return (fieldDisplayText.name + ((!(_.isEmpty(log.params.old_value))) ? " Updated" : " Added"));
        } else {
          var valueDiffrence: any = this.getValueDiffrence(log);
          var targetValue = ""
          var oldTargetValue: any = null;
          this.previousValue = "NA";
          this.currentValue = "NA";
          if (log.event in this.metaDataFieldsMapper) {
            parameter = this.metaDataFieldsMapper[log.event]["field_id"];
            parameterTitle = this.metaDataFieldsMapper[log.event]["message"];
          } else if (log.event in this.externalFieldsMapper) {
            parameterTitle = this.externalFieldsMapper[log.event];
            if (parameterTitle.includes("{{value}}")) {
              parameter = "managers";
            } else {
              return parameterTitle;
            }
          }
          if (valueDiffrence.addedValue && valueDiffrence.addedValue.length) {
            targetValue = this.getDisplayTextForTarget(valueDiffrence.addedValue, parameter);
            this.currentValue = targetValue;
          }
          if (valueDiffrence.removedValue && valueDiffrence.removedValue.length) {
            targetValue = this.getDisplayTextForTarget(valueDiffrence.removedValue, parameter);
            this.previousValue = targetValue;
          }
          if (valueDiffrence.oldValue && valueDiffrence.oldValue.length) {
            oldTargetValue = this.getDisplayTextForTarget(valueDiffrence.oldValue, parameter);
            this.previousValue = oldTargetValue;
          }

          actualAction = parameterTitle.replace("{{value}}", targetValue);

          if (log.event in this.metaDataFieldsMapper) {
            return actualAction.replace("from {{oldValue}}", (oldTargetValue) ? ("from " + oldTargetValue) : "");
          } else {
            return parameterTitle.replace("{{value}}", targetValue);
          }
        }
      } catch (e) { return log.action || log.event }
    }

    return log.action || log.event;
  }
  getValueDiffrence(log) {
    var addedValue = null;
    var removedValue = null;
    var oldValue = null;
    if (!(_.isEmpty(log.params.old_value))) {
      if (_.isArray(log.params.old_value)) {
        if (log.event.includes("REMOVED")) {
          removedValue = _.difference(log.params.old_value, log.params.new_value);
        } else {
          oldValue = log.params.old_value;
          addedValue = _.difference(log.params.new_value, log.params.old_value);
        }
      } else {
        addedValue = log.params.new_value;
      }
    } else {
      addedValue = log.params.new_value;
    }
    return {
      "addedValue": addedValue,
      "removedValue": removedValue,
      "oldValue": oldValue
    }
  }
  getDisplayTextForTarget(values, field) {

    var text = ""
    if (values && values.length) {
      for (var valueIndex = 0; valueIndex < values.length; valueIndex++) {
        if (this.projectMetaDataMap[field][values[valueIndex]]) {
          if (valueIndex == values.length - 1 && values.length > 1) {
            text += ", ";
          }
          var value = this.projectMetaDataMap[field][values[valueIndex]];
          if (value.name) {
            text += value.name
          } else if (value.email_address) {
            text += value.email_address;
          }
        }
      }
    }

    if (text == "") {
      text = (_.isArray(values) && values.length > 0) ? values[0] : values;
      if (text && typeof text === 'string' && text.includes("h_") && text.includes("(")) {
        text = this.extractHiearchyData(text)
      }
    }
    return text;

  }
  extractHiearchyData(text) {
    try {
      if (text.includes("h_") && text.includes("(")) {
        var hierarchy_value = text.substr(text.indexOf("("), text.length)
        var hierarchy_level = (text.replace(hierarchy_value, "")).trim()
        if (this.brandDetails && this.brandDetails.hierarchy_list_alias) {
          for (var hierarchy in this.brandDetails.hierarchy_list_alias) {
            var hierarchyAlias = this.brandDetails.hierarchy_list_alias[hierarchy]
            if (hierarchy_level.includes(hierarchyAlias.name)) {
              var alias = (hierarchyAlias.values).indexOf(hierarchy_level)
              var alias_value = (this.brandDetails.hierarchy_list[hierarchy][alias]) || hierarchy_level;
              return (alias_value + hierarchy_value)
            }
          }
        }
      }
    } catch (e) {
      return text;
    }
  }
  getHistory() {
    this.isHistoryLoaded = false
    const params: any = {
      feed_id: this.feedId,
      is_paging_enabled: true,
      limit: 10,
      page_number: this.pageNumber
    }
    this._feedService.getHistory(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (response.code == 0 && _.hasIn(response, 'data.history') && !_.isEmpty(response.data.history)) {
        this.prepareHistoryData(response.data)
      } else {
        this.data = [];
        this.errorCode = "404"
        this.isHistoryLoaded = true;
      }
    }, (err: any) => {
      this.data = [];
      this.errorCode = '500'
      this.isHistoryLoaded = true;
    })
  }
  initMapper() {
    // Map for all the possible events
    this.metaDataFieldsMapper = {
      "LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED": "field_definitions",
      "LW_RESPONSE_STATUS_CHANGED": { "field_id": "status_list", "message": "Status changed from {{oldValue}} to  {{value}}" },
      "status_changed": { "field_id": "status_list", "message": "Status changed from {{oldValue}} to  {{value}}" },
      "LW_RESPONSE_CATEGORY_CHANGED": { "field_id": "category_list", "message": "Categroy was changed from {{oldValue}} to {{value}}" },
      "category_changed": { "field_id": "category_list", "message": "Categroy was changed from {{oldValue}} to {{value}}" },
      "LW_RESPONSE_TAG_ADDED": { "field_id": "tag_list", "message": "Tag(s) - {{value}} has been added." },
      "LW_RESPONSE_TAG_REMOVED": { "field_id": "tag_list", "message": "Tag(s) - {{value}} has been removed." },
      "LW_RESPONSE_ASSIGNEE_REMOVED": { "field": "assigned_to_id_list", "message": "{{value}} has been removed from assignee." }
    }

    // Map for all the possible events name
    this.eventDetailMapper = {
      "LW_RESPONSE_TEXT_ANALYTICS_UPDATED": { "displayText": "Text Category Updated" },
      "LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED": { "displayText": "Custom Parameter Updated" },
      "LW_RESPONSE_STATUS_CHANGED": { "displayText": "Status Changed" },
      "status_changed": { "displayText": "Status Changed" },
      "LW_RESPONSE_CATEGORY_CHANGED": { "displayText": "Category Changed" },
      "category_changed": { "displayText": "Category Changed" },
      "LW_RESPONSE_TAG_ADDED": { "displayText": "Tag(s) Added" },
      "LW_RESPONSE_TAG_REMOVED": { "displayText": "Tag(s) Removed" },
      "LW_RESPONSE_ASSIGNEE_REMOVED": { "displayText": "Assignee Removed" },
      "LW_RESPONSE_ASSIGNEE_ADDED": { "displayText": "Assignee Added" },
      "LW_RESPONSE_ASSIGNEE_CHANGED": { "displayText": "Assignee Changed" },
      "LW_RESPONSE_FOLLOWERS_ADDED": { "displayText": "Followers Added" },
      "LW_RESPONSE_FOLLOWERS_REMOVED": { "displayText": "Followers Removed" },
      "LW_NOTE_ADDED": { "displayText": "Note Added" },
      "LW_COMMENT_ADDED": { "displayText": "Comment Added" },
      "LW_CUSTOMER_COMMENT": { "displayText": "Customer Comment" },
      "LW_MANAGER_COMMENT": { "displayText": "Manager Comment" },
      "LW_EMAIL_NOTIFICATION": { "displayText": "Email Notification" },
      "LW_SMS_NOTIFICATION": { "displayText": "SMS Notification" },
      "LW_AUTO_RESPONSE": { "displayText": "Auto Reply" },
      "LW_API_REQUEST": { "displayText": "API Request" },
      "LW_PUSH_NOTIFICATIONS": { "displayText": "Push Notification" },
      "LW_AUTO_ASSIGNMENT": { "displayText": "Auto Assignment" },
      "LW_AUTO_ASSIGNMENT_FOLLOWERS": { "displayText": "Auto Assignment" },
      "LW_TS_HOOK_EXECUTED": { "displayText": "SMS/Email Notification" }
    }

    // Map for all the possible external events (Not available at brand meta data)
    this.externalFieldsMapper = {
      "LW_RESPONSE_ASSIGNEE_REMOVED": "{{value}} has been removed from assignee.",
      "LW_RESPONSE_ASSIGNEE_ADDED": "{{value}} has been added as assignee.",
      "LW_RESPONSE_ASSIGNEE_CHANGED": "Assignee changed.",
      "LW_RESPONSE_FOLLOWERS_ADDED": "{{value}} has been added as follower.",
      "LW_RESPONSE_FOLLOWERS_REMOVED": "{{value}} has been removed from followers.",
      "LW_NOTE_ADDED": "A note has been added",
      "LW_COMMENT_ADDED": "A reply has been received",
      "LW_CUSTOMER_COMMENT": "Reply received by the customer",
      "LW_MANAGER_COMMENT": "Replied to the customer"
    }
  }
  prepareAccordionsMap() {

    if (this.brandDetails && this.brandDetails.accordions_list && this.brandDetails.accordions_list.length) {
      this.brandDetails.accordions_list.forEach((accordion) => {
        this.accordionMap[accordion.field_id] = accordion;
      })
    }
  }
  updateExternalMap() {
    try {
      var accordionMap = this.accordionMap;
      this.metaDataFieldsMapper = {
        "LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED": "field_definitions",
        "LW_RESPONSE_STATUS_CHANGED": { "field_id": "status_list", "message": (accordionMap.status.display_name || "Status") + " changed from {{oldValue}} to  {{value}}" },
        "status_changed": { "field_id": "status_list", "message": (accordionMap.status.display_name || "Status") + " changed from {{oldValue}} to  {{value}}" },
        "LW_RESPONSE_CATEGORY_CHANGED": { "field_id": "category_list", "message": (accordionMap.category.display_name || "Category") + " was changed from {{oldValue}} to {{value}}" },
        "category_changed": { "field_id": "category_list", "message": (accordionMap.category.display_name || "Category") + " was changed from {{oldValue}} to {{value}}" },
        "LW_RESPONSE_TAG_ADDED": { "field_id": "tag_list", "message": ("Tag(s) - {{value}} has been added.") },
        "LW_RESPONSE_TAG_REMOVED": { "field_id": "tag_list", "message": ("Tag(s) - {{value}} has been removed.") }
      }
      // Map for all the possible external events (Not available at brand meta data)
      this.externalFieldsMapper = {
        "LW_RESPONSE_ASSIGNEE_REMOVED": "{{value}} has been removed from " + accordionMap.assignee.display_name || "assignee.",
        "LW_RESPONSE_ASSIGNEE_ADDED": "{{value}} has been added as " + accordionMap.assignee.display_name || "assignee.",
        "LW_RESPONSE_ASSIGNEE_CHANGED": (accordionMap.assignee.display_name || "assignee.") + " updated.",
        "LW_RESPONSE_FOLLOWERS_ADDED": "{{value}} has been added as " + accordionMap.follower.display_name || "followers.",
        "LW_RESPONSE_FOLLOWERS_REMOVED": "{{value}} has been removed from " + (accordionMap.follower.display_name || "followers") + ".",
        "LW_NOTE_ADDED": "A " + (accordionMap.notes.display_name || "note") + " has been added",
        "LW_COMMENT_ADDED": "A reply has been received",
        "LW_CUSTOMER_COMMENT": "Reply received by the customer",
        "LW_MANAGER_COMMENT": "Replied to the customer"
      }

      this.eventDetailMapper = {
        "LW_RESPONSE_SIBLINGS_UPDATED": { "displayText": "Related Feeds Updated" },
        "LW_USERS_SKIPPED": { "displayText": "Users Skipped" },
        "LW_REQUEST_TRIGGERED": { "displayText": "Request Triggered" },
        "LW_RESPONSE_TEXT_ANALYTICS_UPDATED": { "displayText": "Text Category Updated" },
        "LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED": { "displayText": "Custom Parameter Updated" },
        "LW_RESPONSE_STATUS_CHANGED": { "displayText": (accordionMap.status.display_name || "Status") + " Changed" },
        "status_changed": { "displayText": (accordionMap.status.display_name || "Status") + " Changed" },
        "LW_RESPONSE_CATEGORY_CHANGED": { "displayText": (accordionMap.category.display_name || "Category") + " Changed" },
        "category_changed": { "displayText": (accordionMap.category.display_name || "Category") + " Changed" },
        "LW_RESPONSE_TAG_ADDED": { "displayText": ("Tag(s) Added") },
        "LW_RESPONSE_TAG_REMOVED": { "displayText": ("Tag(s) Removed") },
        "LW_RESPONSE_ASSIGNEE_REMOVED": { "displayText": (accordionMap.assignee.display_name || "Assignee") + " Removed" },
        "LW_RESPONSE_ASSIGNEE_ADDED": { "displayText": (accordionMap.assignee.display_name || "Assignee") + " Added" },
        "LW_RESPONSE_ASSIGNEE_CHANGED": { "displayText": (accordionMap.assignee.display_name || "Assignee") + " Changed" },
        "LW_RESPONSE_FOLLOWERS_ADDED": { "displayText": (accordionMap.follower.display_name || "Follower") + " Added" },
        "LW_RESPONSE_FOLLOWERS_REMOVED": { "displayText": (accordionMap.follower.display_name || "Follower") + " Removed" },
        "LW_NOTE_ADDED": { "displayText": (accordionMap.notes.display_name || "Note") + " Added" },
        "LW_COMMENT_ADDED": { "displayText": "Comment Added" },
        "LW_CUSTOMER_COMMENT": { "displayText": "Customer Comment" },
        "LW_MANAGER_COMMENT": { "displayText": "Manager Comment" },
        "LW_EMAIL_NOTIFICATION": { "displayText": "Email Notification" },
        "LW_SMS_NOTIFICATION": { "displayText": "SMS Notification" },
        "LW_AUTO_RESPONSE": { "displayText": "Auto Reply" },
        "LW_API_REQUEST": { "displayText": "API Request" },
        "LW_PUSH_NOTIFICATIONS": { "displayText": "Push Notification" },
        "LW_AUTO_ASSIGNMENT": { "displayText": "Auto Assignment" },
        "LW_AUTO_ASSIGNMENT_FOLLOWERS": { "displayText": "Auto Assignment" },
        "LW_TS_HOOK_EXECUTED": { "displayText": "SMS/Email Notification" }
      }
    } catch (e) {
      console.error(e)
      this.initMapper();
    }

  }
}
